/* eslint-disable */
import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";

/* Importing react select */
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

//import translation function for language translation
import { useTranslation } from "react-i18next";

/* import status from json */
import statusData from "../../../data/Prod/Status.json";

//import context
import { GlobalProvider } from "context/GlobalContext";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

const UserManagementFilter = () => {
  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation

  // Returns true when a react-select value has at least one entry selected
  const isSelected = (val) => Array.isArray(val) ? val.length > 0 : !!val;

  // Shared styles for react-select inside a highlighted tile
  const selectedTileStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({ ...base, backgroundColor: "transparent", borderColor: "transparent", boxShadow: "none" }),
  };

  const defaultTileStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  const {
    setSearchUserRoles,
    setSearchUserTags,
    setSearchUserStatus,
    setSearchUserZipcodes,
    setSearchUserCityList,
    setSearchUserStateList,
    setSearchUserCountryList,
    setSearchUserIsCompany,
    setSearchUserCompany,
    setShowUserList,
    isUserListLoading,
  } = useContext(GlobalProvider);

  const [rolesList, setRolesList] = useState([]); //for roles
  const [labelList, setlabelList] = useState([]); // for label list
  const [companyList, setCompanyList] = useState([]); // for company list

  /* useState hook to change select values */
  const [selectedOptions, setSelectedOptions] = useState({
    roleValue: null,
    roleData: [],
    tagValue: null,
    tagData: [],
    statusValue: null,
    statusData: [],
    companyValue: null,
    companyData: [],
    zipCodeValue: null,
    zipCodeData: [],
    cityValue: null,
    cityNames: [],
    stateValue: null,
    stateNames: [],
    countryValue: null,
    countryNames: [],
    isCompany: false,
  });

  //function for get all role
  const getAllRoles = async () => {
    let requestUrl =
      url.API_BASEURL + url.API_GET_ALL_ROLES + `?token=${token}`;

    const response = await getData(requestUrl);

    if (response.status) {
      const filteredData = response.data.filter(
        (item) => item.label !== "admin"
      );
      setRolesList(filteredData);
    }
  };

  /* function to get all labels */
  const getAllLabels = async () => {
    let requestUrl =
      url.API_BASEURL +
      url.API_GET_ALL_TAG +
      `?token=${token}&isselect=${true}`;

    const response = await getData(requestUrl);

    if (response.status) {
      setlabelList(response.data);
    }
  };

  /* function to get company list */
  const getCompanyList = async () => {
    let requestUrl =
      url.API_BASEURL +
      url.API_GET_COMPANY_LIST +
      `?token=${token}&isselect=${true}`;

    const response = await getData(requestUrl);

    if (response.status) {
      setCompanyList(response.data);
    }
  };

  //function for search
  const searchHandler = () => {
    //assign data for search
    selectedOptions.roleData.length > 0 &&
      setSearchUserRoles(selectedOptions.roleData);

    selectedOptions.tagData.length > 0 &&
      setSearchUserTags(selectedOptions.tagData);

    selectedOptions.statusData.length > 0 &&
      setSearchUserStatus(selectedOptions.statusData);

    selectedOptions.companyData.length > 0 &&
      setSearchUserCompany(selectedOptions.companyData);

    selectedOptions.zipCodeData.length > 0 &&
      setSearchUserZipcodes(selectedOptions.zipCodeData);

    selectedOptions.cityNames.length > 0 &&
      setSearchUserCityList(selectedOptions.cityNames);

    selectedOptions.stateNames.length > 0 &&
      setSearchUserStateList(selectedOptions.stateNames);

    selectedOptions.countryNames.length > 0 &&
      setSearchUserCountryList(selectedOptions.countryNames);

    setSearchUserIsCompany(selectedOptions.isCompany);
  };

  //function for reset
  const resetHandler = () => {
    setSelectedOptions({
      roleValue: null,
      roleData: [],
      tagValue: null,
      tagData: [],
      statusValue: null,
      statusData: [],
      companyValue: null,
      companyData: [],
      zipCodeValue: null,
      zipCodeData: [],
      cityValue: null,
      cityNames: [],
      stateValue: null,
      stateNames: [],
      countryValue: null,
      countryNames: [],
      isCompany: false,
    });
    setSearchUserRoles([]);
    setSearchUserTags([]);
    setSearchUserStatus([]);
    setSearchUserCompany([]);
    setSearchUserZipcodes([]);
    setSearchUserCityList([]);
    setSearchUserStateList([]);
    setSearchUserCountryList([]);
    setSearchUserIsCompany(false);
    setShowUserList(true);
  };

  useEffect(() => {
    getAllRoles();
    getAllLabels();
    getCompanyList();
  }, []);

  return (
    <div className="collapse mt-3 user_filter" id="userfilterCollapse">
      <div className="p-3 bg-gray-200">
        <form onSubmit={(e) => e.preventDefault()}>

          {/* ===== BLOCK 1 : Filter by User ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>person_search</span>
              {t("Filter by User")}
            </p>
            <div className="row g-3 align-items-start">

              {/* Role */}
              <div className="col-lg-4">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedOptions.roleValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Role")}</label>
                  <Select
                    placeholder={t("Select role")}
                    isMulti
                    options={rolesList}
                    value={selectedOptions.roleValue}
                    onChange={(val) =>
                      setSelectedOptions((prevData) => ({
                        ...prevData,
                        roleValue: val,
                        roleData: val.map((label) => label.value),
                      }))
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedOptions.roleValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

              {/* Tag */}
              <div className="col-lg-4">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedOptions.tagValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Tag")}</label>
                  <Select
                    placeholder={t("Select tag")}
                    isMulti
                    options={labelList}
                    value={selectedOptions.tagValue}
                    onChange={(val) =>
                      setSelectedOptions((prevData) => ({
                        ...prevData,
                        tagValue: val,
                        tagData: val.map((label) => label.value),
                      }))
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedOptions.tagValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

              {/* Status */}
              <div className="col-lg-4">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedOptions.statusValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Status")}</label>
                  <Select
                    placeholder={t("Select status")}
                    isMulti
                    options={statusData}
                    value={selectedOptions.statusValue}
                    onChange={(val) =>
                      setSelectedOptions((prevData) => ({
                        ...prevData,
                        statusValue: val,
                        statusData: val.map((label) => label.value),
                      }))
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedOptions.statusValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

              {/* Company */}
              <div className="col-lg-4">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedOptions.companyValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Company")}</label>
                  <Select
                    placeholder={t("Select company")}
                    isMulti
                    options={companyList}
                    value={selectedOptions.companyValue}
                    onChange={(val) =>
                      setSelectedOptions((prevData) => ({
                        ...prevData,
                        companyValue: val,
                        companyData: val.map((item) => item.value),
                      }))
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedOptions.companyValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

              {/* Is Company */}
              <div className="col-lg-4">
                <div
                  className={`border rounded px-3 py-2 form-check mb-0 h-100 d-flex align-items-center ${selectedOptions.isCompany ? "border-primary bg-primary bg-opacity-10" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setSelectedOptions((prevData) => ({
                      ...prevData,
                      isCompany: !prevData.isCompany,
                    }))
                  }
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="iscompany"
                    checked={selectedOptions.isCompany}
                    onChange={(e) =>
                      setSelectedOptions((prevData) => ({
                        ...prevData,
                        isCompany: e.target.checked,
                      }))
                    }
                    onClick={(e) => e.stopPropagation()}
                  />
                  <label className="form-check-label small ms-2" htmlFor="iscompany" style={{ cursor: "pointer" }}>
                    {t("Show Company Accounts Only")}
                  </label>
                </div>
              </div>

            </div>
          </div>
          {/* ===== END BLOCK 1 ===== */}

          {/* ===== BLOCK 2 : Filter by Location ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>location_on</span>
              {t("Filter by Location")}
            </p>
            <div className="row g-3">

              {/* Zipcode */}
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedOptions.zipCodeValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Zipcode")}</label>
                  <CreatableSelect
                    placeholder={t("Enter zipcode")}
                    isMulti
                    value={selectedOptions.zipCodeValue}
                    onChange={(val) =>
                      setSelectedOptions((prevData) => ({
                        ...prevData,
                        zipCodeValue: val,
                        zipCodeData: val.map((label) => label.value),
                      }))
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedOptions.zipCodeValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

              {/* City */}
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedOptions.cityValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("City")}</label>
                  <CreatableSelect
                    placeholder={t("Enter City")}
                    isMulti
                    value={selectedOptions.cityValue}
                    onChange={(val) =>
                      setSelectedOptions((prevData) => ({
                        ...prevData,
                        cityValue: val,
                        cityNames: val.map((label) => label.value),
                      }))
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedOptions.cityValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

              {/* State */}
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedOptions.stateValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("State")}</label>
                  <CreatableSelect
                    placeholder={t("Enter State")}
                    isMulti
                    value={selectedOptions.stateValue}
                    onChange={(val) =>
                      setSelectedOptions((prevData) => ({
                        ...prevData,
                        stateValue: val,
                        stateNames: val.map((label) => label.value),
                      }))
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedOptions.stateValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

              {/* Country */}
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedOptions.countryValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Country")}</label>
                  <CreatableSelect
                    placeholder={t("Enter Country")}
                    isMulti
                    value={selectedOptions.countryValue}
                    onChange={(val) =>
                      setSelectedOptions((prevData) => ({
                        ...prevData,
                        countryValue: val,
                        countryNames: val.map((label) => label.value),
                      }))
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedOptions.countryValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

            </div>
          </div>
          {/* ===== END BLOCK 2 ===== */}

          {/* ===== Actions ===== */}
          <div className="d-flex gap-3 align-items-center justify-content-end">
            <Link
              to="#"
              className="d-flex gap-1 align-items-center text-secondary"
              onClick={resetHandler}
            >
              <span className="material-symbols-outlined icon-md">sync</span>
              <span className="fw-medium">{t("Reset")}</span>
            </Link>
            <button
              type="submit"
              className="btn btn-primary px-4 d-flex align-items-center gap-2"
              onClick={searchHandler}
              disabled={isUserListLoading}
            >
              {isUserListLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  {t("Filtering...")}
                </>
              ) : (
                <>
                  <span className="material-symbols-outlined align-middle" style={{ fontSize: "18px" }}>search</span>
                  {t("Filter")}
                </>
              )}
            </button>
          </div>
          {/* ===== End Actions ===== */}

        </form>
      </div>
    </div>
  );
};

export default UserManagementFilter;
